import * as domutils from '../domutils/index';

export class SetGomibukuro {

    element: Element;

    constructor(element: Element) {
        this.element = element;
        element.addEventListener("click", (event) => this.handleClick(event));
    }

    private gomibukuro(): string {
        return domutils.getDatasetValue(this.element, "gomibukuro");
    }

    private dataText(): string {
        return domutils.getDatasetValue(this.element, "text");
    }

    private handleClick(event: Event): any {
        this.gomibukuroElement().value = this.dataText();
    }

    private gomibukuroElement(): HTMLInputElement {
        return domutils.findFirst(document, this.gomibukuro());
    }
}